import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const querySpiderListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/info',
    method: 'get',
    params
  })
}

// 新闻站点列表-批量统计
export const querySpiderListStatApi = (params) => {
  return httpService({
    url: contextPath + '/spider/list/stat',
    method: 'get',
    params
  })
}

// 文献站点-列表
export const querySpiderDocListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/doc/info',
    method: 'get',
    params
  })
}

export const querySpiderApiListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/api/info',
    method: 'get',
    params
  })
}

export const querySpiderTwitterListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/twitter/info',
    method: 'get',
    params
  })
}

export const stopSpiderByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/api/item/stop',
    method: 'put',
    params
  })
}

export const stopSpider = (params) => {
  return httpService({
    url: contextPath + '/spider/item/stop',
    method: 'put',
    params
  })
}

export const stopTwitterSpiderByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/twitter/item/stop',
    method: 'put',
    params
  })
}

export const deleteSpiderItemApi = (params) => {
  return httpService({
    url: contextPath + '/spider/item',
    method: 'delete',
    params
  })
}

export const execSpiderByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/item/exec',
    method: 'put',
    params
  })
}

export const execSpiderTwitterByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/twitter/item/exec',
    method: 'put',
    params
  })
}

export const execSpiderApiByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/api/item/exec',
    method: 'put',
    params
  })
}

// 手动执行站点
export const execNewsItemApi = (params) => {
  return httpService({
    url: contextPath + '/spider/item/handExec',
    method: 'put',
    params
  })
}

//手动执行站点自媒体版
export const execTwitterItemApi = (params) => {
  return httpService({
    url: contextPath + '/spider/twitter/item/handExec',
    method: 'put',
    params
  })
}

// 手动执行api/头条版
export const execApiItemApi = (params) => {
  return httpService({
    url: contextPath + '/spider/api/item/handExec',
    method: 'put',
    params
  })
}

// 下载导入模板
export const downloadTemplate = (params) => {
  return httpService({
    url: contextPath + '/spider/doc/importTemplate',
    method: 'get',
    params
  })
}

// 导入模板接口
export const uploadTemplate = (data) => {
  return httpService({
    url: contextPath + '/spider/doc/batchImport',
    method: 'post',
    apiType: 'file',
    data
  })
}

